import { useEffect, useState } from 'react';
import { useUsersApi } from '@enter/api';

const DEFAULT_REWARD = 100;

export function useReferralRewards(enabled = true) {
    const usersApi = useUsersApi();
    const [inviterReward, setInviterReward] = useState(DEFAULT_REWARD);
    const [inviteeReward, setInviteeReward] = useState(DEFAULT_REWARD);

    useEffect(() => {
        if (!enabled) return;
        let cancelled = false;

        void usersApi
            .getReferralRewards()
            .then(response => {
                if (cancelled || (response.code !== 0 && response.code !== 200)) {
                    return;
                }

                setInviterReward(response.data.inviter_reward ?? DEFAULT_REWARD);
                setInviteeReward(response.data.invitee_reward ?? DEFAULT_REWARD);
            })
            .catch(error => {
                console.error('Failed to load referral rewards:', error);
            });

        return () => {
            cancelled = true;
        };
    }, [enabled, usersApi]);

    return {
        inviterReward,
        inviteeReward,
    };
}
